import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import InputAdornment from '@mui/material/InputAdornment';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import axios from 'axios'; // Asegúrate de tener axios instalado
import "../modal.css";
import Card from '@mui/material/Card';

export default function AgregarDescripcion() {
    const [abierto, setAbierto] = useState(false);
    const [especificaciones, setEspecificaciones] = useState(['']);
    const [checkeds, setCheckeds] = useState([false]);
    const [listas, setListas] = useState([[]]);
    const [nuevoItems, setNuevoItems] = useState(['']);
    const [imagen, setImagen] = useState(null);
    const [descripcion, setDescripcion] = useState('');
    const [codigoGenerico, setCodigoGenerico] = useState('');

    const abrirModal = () => setAbierto(true);
    const cerrarModal = () => {
        setAbierto(false);

        // Limpiar los campos del formulario
        setEspecificaciones(['']);
        setCheckeds([false]);
        setListas([[]]);
        setNuevoItems(['']);
        setImagen(null);
        setDescripcion('');
        setCodigoGenerico('');
    }

    const agregarEspecificacion = () => {
        if (especificaciones.length < 8) {
            setEspecificaciones([...especificaciones, '']);
            setCheckeds([...checkeds, false]);
            setListas([...listas, []]);
            setNuevoItems([...nuevoItems, '']);
        }
    };

    const quitarEspecificacion = () => {
        if (especificaciones.length > 1) {
            const nuevasEspecificaciones = [...especificaciones];
            const nuevosCheckeds = [...checkeds];
            const nuevasListas = [...listas];
            const nuevosNuevoItems = [...nuevoItems];

            nuevasEspecificaciones.pop();
            nuevosCheckeds.pop();
            nuevasListas.pop();
            nuevosNuevoItems.pop();

            setEspecificaciones(nuevasEspecificaciones);
            setCheckeds(nuevosCheckeds);
            setListas(nuevasListas);
            setNuevoItems(nuevosNuevoItems);
        }
    };

    const manejarCambioEspecificacion = (indice, valor) => {
        const nuevasEspecificaciones = [...especificaciones];
        nuevasEspecificaciones[indice] = valor;
        setEspecificaciones(nuevasEspecificaciones);
    };

    const manejarCambioCheckbox = (indice, valor) => {
        const nuevosCheckeds = [...checkeds];
        nuevosCheckeds[indice] = valor;
        setCheckeds(nuevosCheckeds);

        if (!valor) {
            const nuevasListas = [...listas];
            nuevasListas[indice] = [];
            setListas(nuevasListas);
            setNuevoItems(prevNuevoItems => {
                const nuevoItemsActualizado = [...prevNuevoItems];
                nuevoItemsActualizado[indice] = '';
                return nuevoItemsActualizado;
            });
        }
    };

    const manejarSubidaImagen = (e) => {
        if (e.target.files && e.target.files[0]) {
            setImagen(e.target.files[0]);
        }
    };

    const manejarCambioLista = (indice, nuevoValor) => {
        const nuevasListas = [...listas];
        nuevasListas[indice] = nuevoValor;
        setListas(nuevasListas);
    };

    const manejarCambioNuevoItem = (indice, valor) => {
        const nuevosNuevoItems = [...nuevoItems];
        nuevosNuevoItems[indice] = valor;
        setNuevoItems(nuevosNuevoItems);
    };

    const manejarAgregarItem = (indice) => {
        if (nuevoItems[indice].trim()) {
            const nuevasListas = [...listas];
            nuevasListas[indice] = [...nuevasListas[indice], nuevoItems[indice]];
            setListas(nuevasListas);
            manejarCambioNuevoItem(indice, '');
        }
    };

    const manejarEliminarItem = (indice, item) => {
        const nuevasListas = [...listas];
        nuevasListas[indice] = nuevasListas[indice].filter(i => i !== item);
        setListas(nuevasListas);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const userData = JSON.parse(localStorage.getItem('usuario'));
        const empresa_idEmpresa = userData.empresa_idEmpresa

        const formData = new FormData();
        formData.append('descripcion', descripcion);
        formData.append('codigoGenerico', codigoGenerico);
        formData.append('empresa_idEmpresa', empresa_idEmpresa);

        especificaciones.forEach((especificacion, index) => {
            formData.append(`especificaciones[${index}]`, especificacion);
            formData.append(`checkeds[${index}]`, checkeds[index]);
            if (checkeds[index]) {
                listas[index].forEach((item, itemIndex) => {
                    formData.append(`opciones[${index}][${itemIndex}]`, item);
                });
            }
        });

        if (imagen) {
            formData.append('imagen', imagen);
        }

        try {
            const response = await axios.post('https://invio.datachile.site/Web/Productos/CrearDescripcion.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log('Datos enviados exitosamente:', response.data);
            cerrarModal();
            window.location.reload();
        } catch (error) {
            console.error('Error al enviar los datos:', error);
        }
        console.log(Array.from(formData.entries()));

    };

    return (
        <div>
            <div style={{ marginBottom: '16px' }}>
                <IconButton
                    onClick={abrirModal}
                    color="primary"
                    style={{
                        padding: '6px 12px',
                        backgroundColor: '#1976d2',
                        color: 'white',
                        borderRadius: '4px',
                        fontSize: '14px',
                    }}
                >
                    <span>Crear Producto</span>
                </IconButton>
            </div>
            <Modal
                open={abierto}
                onClose={cerrarModal}
                aria-labelledby="modal-titulo"
                aria-describedby="modal-descripcion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 800,
                        maxHeight: '90vh',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                        overflowY: 'auto',
                    }}
                >
                    <Typography id="modal-titulo" variant="h6" component="h2" gutterBottom>
                        Crear producto
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={9}>
                                <TextField
                                    fullWidth
                                    label="Descripción"
                                    variant="outlined"
                                    size="small"
                                    margin="dense"
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                    sx={{ mb: 0 }}
                                />
                                <TextField
                                    fullWidth
                                    label="Código Genérico"
                                    variant="outlined"
                                    size="small"
                                    margin="dense"
                                    value={codigoGenerico}
                                    onChange={(e) => setCodigoGenerico(e.target.value)}
                                    sx={{ mb: 0 }}
                                />
                                {especificaciones.map((especificacion, index) => (
                                    <Grid container spacing={1} key={index} alignItems="center">
                                        <Grid item xs={6} md={5}>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                margin="dense"
                                                label={`Especificación ${index + 1}`}
                                                value={especificacion}
                                                onChange={(e) => manejarCambioEspecificacion(index, e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={1}>
                                            <Typography variant="body2" color="textSecondary" gutterBottom>
                                                Listar
                                            </Typography>
                                            <Checkbox
                                                checked={checkeds[index]}
                                                onChange={(e) => manejarCambioCheckbox(index, e.target.checked)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            {checkeds[index] && (
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    margin="dense"
                                                    label="Especificaciones"
                                                    value={nuevoItems[index]}
                                                    onChange={(e) => manejarCambioNuevoItem(index, e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            manejarAgregarItem(index);
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    onClick={() => manejarAgregarItem(index)}
                                                                    color="primary"
                                                                >
                                                                    <AddCircleIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    fullWidth
                                                    sx={{ mb: 1 }}
                                                />
                                            )}
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                {listas[index].map((item, itemIndex) => (
                                                    <Chip
                                                        key={itemIndex}
                                                        label={item}
                                                        onDelete={() => manejarEliminarItem(index, item)}
                                                        sx={{ mb: 1 }}
                                                    />
                                                ))}
                                            </div>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
                                    <IconButton
                                        onClick={agregarEspecificacion}
                                        color="primary"
                                        size="small"
                                    >
                                        <AddIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={quitarEspecificacion}
                                        color="secondary"
                                        size="small"
                                    >
                                        <RemoveIcon />
                                    </IconButton>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Box>
                                    <label htmlFor="imagen-upload">
                                        <input
                                            accept="image/*"
                                            id="imagen-upload"
                                            type="file"
                                            style={{ display: 'none' }}
                                            onChange={manejarSubidaImagen}
                                        />
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            sx={{ mb: 2, width: '100%' }}
                                        >
                                            Subir Imagen
                                        </Button>
                                    </label>
                                    {imagen && (
                                        <Card
                                            sx={{
                                                mt: 2,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                p: 2,
                                            }}
                                        >
                                            <img
                                                src={URL.createObjectURL(imagen)}
                                                alt="Previsualización"
                                                style={{ maxWidth: '100%', maxHeight: '150px' }}
                                            />
                                            <Typography variant="caption">{imagen.name}</Typography>
                                        </Card>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ mt: 2 }}
                            >
                                Guardar
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>
        </div>
    );
}
